import { env } from 'utils/env';

const url = env.REACT_APP_LEASING_API_URL;

export const buildExportDownloadUrl = async (filePath, fileName, accessToken) => {
  return `${url}/DownloadList/export/file/${encodeURIComponent(filePath)}/${encodeURIComponent(fileName)}?access_token=${accessToken}`;
};
